import { takeLatest, put } from 'redux-saga/effects';
import { PATIENT_INSURANCE_STATUS } from '../../../../constants';
import { actions as updatePatientInsurance } from '../../../manage-insurances/requests/update-patient-insurance';
import { actions as scheduledTasksUpcomingReqActions } from '../../../healthboard/requests/scheduled-tasks-upcoming-req';

function* handleChangePatientInsuranceCard({ payload }) {
  const { status, frontSide, backSide, id } = payload;

  if (status === PATIENT_INSURANCE_STATUS.DRAFT) {
    yield put(
      scheduledTasksUpcomingReqActions.updateInsuranceCardForToDoTask({
        id,
        frontSide,
        backSide,
      }),
    );
  }
}

export function* watchChangePatientInsuranceCard() {
  yield takeLatest(
    updatePatientInsurance.succeed,
    handleChangePatientInsuranceCard,
  );
}



// WEBPACK FOOTER //
// ./src/redux/profiles/sagas/patientInsurance/patient-insurance-card.js